<template>
    <div class="py-4 container-fluid">
        <div v-if="!isLoaded" class="row">
            <LoadingScreen :message="'Cargando Información de Proyectos'" />
        </div>
        <div v-if="isLoaded" class="row">
            <div class="col-lg-8">
                <div class="card mb-3">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex justify-content-between">
                            <h6 class="mb-2">Proyectos</h6>
                            <button type="button" class="btn btn-warning" @click="newProject">
                                + Agregar Proyecto
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- Buscador de proyectos -->
                        <div class="mb-3">
                            <input v-model="projectSearch" type="text" class="form-control"
                                placeholder="Buscar proyectos...">
                        </div>

                        <div class="table-responsive">
                            <table class="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Proyecto</th>
                                        <th>Cliente</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="project in filteredProjects" :key="project.project_id">
                                        <td>{{ project.identifier }} - {{ project.project }}</td>
                                        <td>{{ project.client }}</td>
                                        <td>
                                            <button class="btn btn-secondary me-2 mb-0"
                                                @click="editProject(project.project_id)">
                                                <i class="bi bi-pencil-square"></i> Editar
                                            </button>
                                            <button class="btn btn-warning mb-0"
                                                @click="goToProjectsUsers(project.project_id)">
                                                <i class="bi bi-people-fill"></i> Colaboradores
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="filteredProjects.length === 0">
                                        <td colspan="3" class="text-center">No se encontraron proyectos</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Paginación de proyectos -->
                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <div>
                                <select v-model.number="projectsPerPage" class="form-select form-select-sm"
                                    style="width: auto;">
                                    <option :value="5">5 por página</option>
                                    <option :value="10">10 por página</option>
                                    <option :value="15">15 por página</option>
                                    <option :value="20">20 por página</option>
                                </select>
                            </div>
                            <div>
                                Mostrando {{ projectStartIndex + 1 }} a {{ projectEndIndex }} de {{ projects.length }}
                                proyectos
                            </div>
                            <div>
                                <button class="btn btn-sm btn-secondary me-1 mb-0" @click="projectCurrentPage--"
                                    :disabled="projectCurrentPage === 1">
                                    <i class="bi bi-chevron-left"></i>
                                </button>
                                <span class="mx-2">{{ projectCurrentPage }} de {{ projectTotalPages }}</span>
                                <button class="btn btn-sm btn-secondary mb-0" @click="projectCurrentPage++"
                                    :disabled="projectCurrentPage === projectTotalPages">
                                    <i class="bi bi-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="card mb-3">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex justify-content-between">
                            <h6 class="mb-2">Clientes</h6>
                            <button type="button" class="btn btn-warning" @click="openModal({}, 'CreateClient')">
                                + Agregar Cliente
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- Buscador de clientes -->
                        <div class="mb-3">
                            <input v-model="clientSearch" type="text" class="form-control"
                                placeholder="Buscar clientes...">
                        </div>

                        <div class="table-responsive">
                            <table class="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Cliente</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="client in filteredClients" :key="client.client_id">
                                        <td>{{ client.client }}</td>
                                        <td>
                                            <button class="btn btn-secondary mb-0" @click="openModal({
                                                client_id: client.client_id,
                                                client: client.client,
                                                location: client.location,
                                                color_code: client.color_code
                                            }, 'EditClient')">
                                                <i class="bi bi-pencil-square"></i> Editar
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="filteredClients.length === 0">
                                        <td colspan="2" class="text-center">No se encontraron clientes</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Paginación de clientes -->
                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <div>
                                <select v-model.number="clientsPerPage" class="form-select form-select-sm"
                                    style="width: auto;">
                                    <option :value="5">5 por página</option>
                                    <option :value="10">10 por página</option>
                                    <option :value="15">15 por página</option>
                                    <option :value="20">20 por página</option>
                                </select>
                            </div>
                            <div>
                                {{ clientStartIndex + 1 }} a {{ clientEndIndex }} de {{ clients.length }}
                            </div>
                            <div>
                                <button class="btn btn-sm btn-secondary me-1 mb-0" @click="clientCurrentPage--"
                                    :disabled="clientCurrentPage === 1">
                                    <i class="bi bi-chevron-left"></i>
                                </button>
                                <span class="mx-2">{{ clientCurrentPage }} de {{ clientTotalPages }}</span>
                                <button class="btn btn-sm btn-secondary mb-0" @click="clientCurrentPage++"
                                    :disabled="clientCurrentPage === clientTotalPages">
                                    <i class="bi bi-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Modal :isOpen="isModalOpen" :title="modalTitle" :selectedFormComponent="selectedFormComponent"
        :selectedData="selectedData" @close="closeModal" />
</template>

<script setup>
import { useRouter } from 'vue-router';
import { onMounted, ref, computed, shallowRef } from 'vue';
import axios from 'axios';

const token = localStorage.getItem('authToken');
const API_BASE_URL = process.env.VUE_APP_BASE_URL;
const router = useRouter();

import Modal from "./components/Modal.vue";
import CreateClient from './components/forms/CreateClient.vue';
import EditClient from './components/forms/EditClient.vue';
import LoadingScreen from './components/LoadingScreen.vue';

const formComponents = {
    EditClient: EditClient,
    CreateClient: CreateClient,
};

// Pantalla de Carga
const isLoaded = ref(false)

// Estados del modal
const isModalOpen = ref(false);
const selectedFormComponent = shallowRef(null);
const modalTitle = ref("");
const selectedData = ref(null);

// Datos
const clients = ref([]);
const projects = ref([]);

// Búsqueda
const clientSearch = ref('');
const projectSearch = ref('');

// Paginación
const clientsPerPage = ref(10);
const projectsPerPage = ref(10);
const clientCurrentPage = ref(1);
const projectCurrentPage = ref(1);

// Clientes filtrados por búsqueda
const filteredClients = computed(() => {
    if (!clientSearch.value) {
        return paginatedClients.value;
    }
    const search = clientSearch.value.toLowerCase();
    const filtered = clients.value.filter(client =>
        client.client.toLowerCase().includes(search) ||
        (client.location && client.location.toLowerCase().includes(search))
    );
    return filtered.slice(clientStartIndex.value, clientEndIndex.value);
});

// Proyectos filtrados por búsqueda
const filteredProjects = computed(() => {
    if (!projectSearch.value) {
        return paginatedProjects.value;
    }
    const search = projectSearch.value.toLowerCase();
    const filtered = projects.value.filter(project =>
        project.project.toLowerCase().includes(search) ||
        project.identifier.toLowerCase().includes(search) ||
        project.client.toLowerCase().includes(search)
    );
    return filtered.slice(projectStartIndex.value, projectEndIndex.value);
});

// Paginación de clientes
const clientTotalPages = computed(() =>
    Math.ceil(clients.value.length / clientsPerPage.value) || 1
);

const clientStartIndex = computed(() =>
    (clientCurrentPage.value - 1) * clientsPerPage.value
);

const clientEndIndex = computed(() =>
    Math.min(clientStartIndex.value + clientsPerPage.value, clients.value.length)
);

const paginatedClients = computed(() =>
    clients.value.slice(clientStartIndex.value, clientEndIndex.value)
);

// Paginación de proyectos
const projectTotalPages = computed(() =>
    Math.ceil(projects.value.length / projectsPerPage.value) || 1
);

const projectStartIndex = computed(() =>
    (projectCurrentPage.value - 1) * projectsPerPage.value
);

const projectEndIndex = computed(() =>
    Math.min(projectStartIndex.value + projectsPerPage.value, projects.value.length)
);

const paginatedProjects = computed(() =>
    projects.value.slice(projectStartIndex.value, projectEndIndex.value)
);

// Función para agregar proyecto (redireccionar)
const newProject = () => {
    router.push(`/new-project`);
};

// Función para editar proyecto (redireccionar)
const editProject = (projectId) => {
    router.push(`/project/${projectId}`);
};

// Función para agregar colaboradores al proyecto (redireccionar)
const goToProjectsUsers = (id) => {
    router.push(`/project-users/${id}`)
}

// Función para abrir el modal
const openModal = (data, formType) => {
    selectedData.value = data || {};
    selectedFormComponent.value = formComponents[formType] || null;

    const titles = {
        EditClient: "Editar Cliente",
        EditProject: "Editar Proyecto",
        CreateClient: "Agregar Cliente",
        CreateProject: "Agregar Proyecto",
        EditProjectUsers: "Colaboradores del Proyecto",
    };
    modalTitle.value = titles[formType] || "Editar Información";
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
    // Refrescar datos después de cerrar el modal
    fetchClientsData();
    fetchProjectsData();
};

// Función para obtener los datos de los clientes
const fetchClientsData = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/clients`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        clients.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
};

// Función para obtener los datos de los proyectos
const fetchProjectsData = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/projects`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        projects.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos de proyectos:', error);
    }
};

const getData = async () => {
    await fetchProjectsData()
    await fetchClientsData()
    isLoaded.value = true
}

// Inicializar datos
onMounted(async () => {
    await getData()
});
</script>